import React from 'react'
import NavigationSection from "../../../core/model2/navigation/navigation-section"
import {ReorderItemProps} from "../../../core/gd-ui/sortable-list-4/@types"
import Navigation_ButtonHint from "../components/hint/hint-section";
import PopoverMenu from "../../../core/gd-components/popover-menu/popover-menu/popover-menu";
import Navigation_BaseButton from "./base-button";

type Props = {
    className?          : string,

    section             : NavigationSection,

    inMorePopover       : boolean

    onClickCallback?    : callback

} & ReorderItemProps

// const debug = "Navigation_ButtonGeneric"
const debug = false

// this is for NAvigations section and Depricated - use one for the space in the future
export default class Navigation_ButtonGenericDeprecated extends React.Component<Props> {

    // public refHint                  : React.RefObject<NavigationHint> = React.createRef<NavigationHint>()
    public refHint                  : React.RefObject<Navigation_ButtonHint> = React.createRef<Navigation_ButtonHint>()

    componentWillUnmount() {
        if (gd.layout.contextMenu.hover?.component === this) {
            gd.layout.contextMenu.hover.component = null
            gd.layout.contextMenu.hide()
        }
    }

    showContextMenu = (e: React.MouseEvent) => {
        e.stopPropagation()
        e.preventDefault()

        let options : Option[] = []

        if (this.props.section.space) {

            options = this.props.section.space.contextMenuOptions

        } else {

            // if (this.props.section.space?.isWorkspace) {
            //     options.push({
            //         label       : "Info",
            //         icon        : 'ii5-information',
            //         onClick     : () => {
            //             const workspace :Workspace = this.props.section.space as Workspace
            //             workspace.project.goToInfo()
            //         }
            //     })
            // }

            options = options.concat(this.props.section.positionOptions)
        }


        if (_.size(options) < 1) {
            return null
        }

        debug && console.log(debug, 'showContextMenu', e)

        gd.layout.contextMenu.show(e,
            <PopoverMenu options        = {options}
                         hidePopover    = {() => gd.layout.contextMenu.hide()}/>,
            {
                component: this
            }
        )
    }

    onClick = (e:React.MouseEvent) => {
        debug && console.log(debug, 'onClick', e)

        e.stopPropagation()

        if (this.props.onClickCallback) this.props.onClickCallback()

        this.refHint?.current?.hideHint()

        this.props.section.onClick && this.props.section.onClick(this.props.section)
    }

    render() {
        const isSelected = gd.layout.navigation.state.currentSection?.id === this.props.section.id   // yes by id not object

        // Old
        // let icon = (this.props.section.iconActive && isSelected && !this.props.inMorePopover) ? this.props.section.iconActive : this.props.section.icon

        // New
        let icon = this.props.section.icon

        const showHintButton = !this.props.inMorePopover && !this.props.dndIsDragInProgress

        // style is required for ReorderList (pointer-events: none)
        return (
            <Navigation_BaseButton
                className           = {this.props.className}
                icon                = {icon}
                label               = {this.props.section.name}
                style               = {this.props.style}
                isSelected          = {isSelected}
                dndPreview          = {this.props.dndPreview}
                dndIsDragged        = {this.props.dndIsDragged}
                inMorePopover       = {this.props.inMorePopover}
                dndIsDragInProgress = {this.props.dndIsDragInProgress}
                isMouseEntered      = {this.props.isMouseEntered}
                onClick             = {this.onClick}
                showContextMenu     = {this.showContextMenu}
            >
                {showHintButton &&
                    <Navigation_ButtonHint
                        ref     = {this.refHint}
                        section = {this.props.section}
                    />
                }
            </Navigation_BaseButton>
        )
    }
}
